const Footer = () => {
  return (
    <footer>
      <div className="container py-4">
        <div className="row py-4">
          <div className="col-12 d-flex justify-content-center align-items-center gap-2 flex-column">
            <span className="text-muted mb-2">Made with ❤️ by</span>
            <div className="w-50 d-flex justify-content-center">
            <img src="https://storybook.talentech.io/images/svg/LogoTalentech.svg" alt="logo" className="w-25" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;